export const closeLabels = { en: 'Close', es: 'Cerrar', zh: '關閉', sc: '关闭' };
